module.exports = __webpack_public_path__ + "img/Image-new.3f81fa4b.svg";